<template>
  <div class="product-gallery">
    <div class="gallery-main image-frame" :class="{ 'image-frame--fallback': imageFailed }">
      <picture v-if="currentImage && !imageFailed" :key="currentImage" class="gallery-main__media">
        <source v-if="currentMobileImage" media="(max-width: 768px)" :srcset="currentMobileImage">
        <img :src="currentImage" :alt="product.name || $store.getters.t('productImage')" @error="imageFailed = true">
      </picture>
      <span v-else>{{ product.name || $store.getters.t('product') }}</span>
      <button v-if="images.length > 1" type="button" class="gallery-arrow gallery-arrow--left" title="Previous image" aria-label="Previous image" @click="previous">‹</button>
      <button v-if="images.length > 1" type="button" class="gallery-arrow gallery-arrow--right" title="Next image" aria-label="Next image" @click="next">›</button>
    </div>
    <div v-if="images.length > 1" class="gallery-thumbs">
      <button v-for="(image, index) in images" :key="`${image}-${index}`" type="button" :class="{ active: index === activeIndex }" @click="goTo(index)">
        <img :src="image" :alt="`${product.name || 'Product'} ${index + 1}`">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductGallery',
  props: { product: { type: Object, default: () => ({}) }, preferredImage: String },
  data () { return { activeIndex: 0, imageFailed: false } },
  computed: {
    images () {
      const list = [this.product.coverImage]
        .concat((this.product.images || []).map(item => typeof item === 'string' ? item : item && (item.imageUrl || item.url)))
        .concat((this.product.colors || []).map(item => item.imageUrl))
      return list.filter((image, index) => image && list.indexOf(image) === index)
    },
    currentImage () { return this.preferredImage || this.images[this.activeIndex] || this.product.coverImage || '' },
    currentMobileImage () {
      const image = (this.product.images || []).find(item => item && typeof item !== 'string' && (item.imageUrl || item.url) === this.currentImage)
      return image && (image.mobileImageUrl || image.mobile_image_url) || ''
    }
  },
  watch: {
    product () { this.activeIndex = 0; this.imageFailed = false },
    preferredImage: {
      immediate: true,
      handler (image) {
        const index = this.images.indexOf(image)
        if (index > -1) this.activeIndex = index
        this.imageFailed = false
      }
    },
    activeIndex () { this.imageFailed = false }
  },
  methods: {
    next () { this.activeIndex = (this.activeIndex + 1) % this.images.length },
    previous () { this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length },
    goTo (index) { this.activeIndex = index }
  }
}
</script>
